import { createContext } from "react";

const PasswordContext = createContext();

export default PasswordContext;